import React from 'react'

const stats = [
  {
    label: "Projects Completed",
    sub: "Delivered Projects",
    value: "30+",
  },
  {
    label: "Happy Clients",
    sub: "Client Satisfaction",
    value: "98%",
  },
  {
    label: "Team Productivity",
    sub: "Workflow Performance",
    value: "85%",
  },
  {
    label: "Growth Rate",
    sub: "Annual Business Growth",
    value: "120%",
  },
  {
    label: "Customer Retention",
    sub: "Returning Client Ratio",
    value: "92%",
  },
  {
    label: "Client Retention",
    sub: "Client Retention",
    value: "90%",
  },
];
function PerformaceData() {
  return (
        
<section className="py-16 px-6 lg:px-16 bg-[#f8f8f8] dark:bg-[#050505] relative overflow-hidden">
      {/* GRID BACKGROUND */}
      <div className="absolute inset-0 opacity-50 bg-[linear-gradient(rgba(0,0,0,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.05)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:60px_60px]" />

      <div className="relative z-10 max-w-7xl mx-auto">
             <div className="text-center mb-12 md:mb-16">
                  <h2 className="myheading text-3xl md:text-5xl text-center">
         Our Performance {" "}
            <span className="bg-gradient-to-r from-primary via-orange-400 to-yellow-500 bg-clip-text text-transparent">
              Data
            </span>
          </h2>
      <p className="myparagraph text-gray-500">
  We are continuously focused on growth, innovation, and delivering excellence through disciplined execution.
</p>
      </div>
      
        {/* CARDS GRID */}
        <div className="grid grid-cols-2 md:grid-cols-6 lg:grid-cols-6 gap-3">
          {stats.map((stat, index) => (
            <div 
              key={index} 
              className="bg-white dark:bg-[#111] overflow-hidden pt-6 rounded-3xl border border-gray-200 dark:border-gray-800 "
            >
              <div className="pl-6">
                <h3 className="text-3xl font-bold text-gray-900 dark:text-white">{stat.value}</h3>
              <p className="text-xs md:text-sm text-gray-500 dark:text-gray-400 mb-2">{stat.sub}</p>
              </div>
              
              {/* GRAPH SHAPE (SVG Wave) */}
            <svg viewBox="0 0 100 40" className="w-full h-30 text-primary">
  <path 
    fill="currentColor" 
    d="M0 40 
       C 15 20, 25 10, 40 20 
       C 55 30, 65 35, 80 20 
       C 90 10, 95 15, 100 15 
       L 100 40 Z" 
  />
</svg>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default PerformaceData
